<template>
  <v-card
      class="py-2"
      elevation="0"
      color="#F5F5F5"
  >
    <section class="d-flex align-center justify-space-between">
      <section class="page pl-3">
        {{ ((currentPage - 1) * pageSize) + 1 }} -
        {{ pageCount }} de
        {{ totalItems }}
      </section>

      <section>
        <v-btn
            class="btn-table"
            icon
            :disabled="currentPage === 1"
            @click="backPage()"
            color="#BC0000"
        >
          <v-icon
              size="30"
              color="#BC0000"
              class="icon-back"
          >
            mdi-chevron-left
          </v-icon>
        </v-btn>
        <v-btn
            class="btn-table"
            icon
            :disabled="currentPage === totalPages"
            @click="nextPage()"
            color="#BC0000"
        >
          <v-icon
              class="icon-next"
              size="30"
              color="#BC0000"
          >
            mdi-chevron-right
          </v-icon>
        </v-btn>
      </section>
    </section>
  </v-card>
</template>


<script>

export default {
  name: "Pagination",

  props: {
    currentPage: {type: Number, default: 1},
    totalItems: {type: Number, default: 1},
    page: {type: Number, default: 1},
    pageSize: {type: Number, default: 1},
    totalPages: {type: Number, default: 1},
  },

  data: () => ({}),

  computed: {
    pageCount() {
      if (this.totalItems < this.pageSize || this.page === this.totalPages) {
        return this.totalItems
      } else {
        return this.pageSize * this.currentPage
      }
    },
  },

  methods: {
    backPage() {
      this.$emit('back-page');
    },
    nextPage() {
      this.$emit('next-page');
    },
  },
};
</script>

<style  scoped>
.page {
  color: #BC0000 !important;
  font-weight: 700;
}

.btn-table:hover {
  .icon-next, .icon-back{
  }
}
</style>